import * as yup from "yup";
import {
    nameRule,
    priceRule,
    creditRule,
    recruitersRule,
    planEndDaysRule,
} from "../commonRules";

export const subscriptionPlanSchema = yup.object().shape({
    plan_name: nameRule("Plan Name", { required: true }),
    price: priceRule("Price", { required: true }),
    credit: creditRule("Credits", { required: true }),
    allowed_recruiter_count: recruitersRule("Allowed Recruiters", { required: true }),
    plan_expired_in_days: planEndDaysRule("Plan End in Days", { required: false }),
});

export default subscriptionPlanSchema;
